import React from 'react';

const History = () => (
  <>
    <style>{`
@font-face {
  font-family: 'CustomFont';
  src: url('/Orbitron/Orbitron-VariableFont_wght.ttf') format('woff2'),
       url('/Orbitron/Orbitron-VariableFont_wght.ttf') format('woff');
  font-weight: normal;
  font-style: normal;
}

body {
  font-family: 'CustomFont', sans-serif;
  margin: 0;
  padding: 0;
  background-color: #000;
  color: #fff;
}

header {
  background-color: #000;
  color: #fff;
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: center;
  position: relative;      /* add this line */
}
  .buy-coffee {
  position: absolute;
  top: 20px;            /* lines up with header padding */
  right: 20px;
  color: #f5c65d;
  text-decoration: none;
  line-height: 1.1;
    font-size: 0.93rem;
  text-align: center;
  font-family: 'CustomFont', sans-serif;
}

nav {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

nav a {
  color: #fff;
  text-decoration: none;
}

nav a:active {
  color: #f5c65d;
}

.social-links {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 15px;
}

.social-links a {
  color: #f5c65d;
  text-decoration: none;
}

.header-logo {
  width: 250px;
  height: auto;
  /* Change the width above to resize the logo */
}

footer {
  background-color: #000;
  color: #fff;
  text-align: center;
  padding: 0px 0;
  position: fixed;
  font-size: 0.73rem;
  bottom: 0;
  width: 100%;
}

@media screen and (max-width:600px){
  nav {
    flex-wrap: wrap;
    gap: 10px;
  }
}

.timeline {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: flex-start;
  margin-top: 20px;
}

.timeline-item {
  width: 45%;
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  background-color: #111;
}

.timeline-item img {
  max-width: 25%;
  height: auto;
  border-radius: 5px;
}

.timeline-item p {
  margin-top: 10px;
  color: #fff;
}

@media screen and (max-width:600px){
  .timeline-item {
    width: 90%;
  }
}

h2 {
  color: #f5c65d;
  text-align: center;
  margin-top: 20px;
}
`}</style>



    <main>
      <section>
        <h2>History</h2>
        <div className="timeline">
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/pistolhittin.jpg" alt="" />
            <p>Pistol “Hitting like a bullet” was the first album released on Street Flavor Records and later re-released on a co-label deal with Ruthless Records in 1993.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/boogie.png" alt="" />
            <p>Boogie “under da influenz” was the second album released by Street Flavor Records in 1994. Later that year Street Flavor did a joint label deal with Relativity.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/killedme.jpg" alt="" />
            <p>Pistol “They shouldve killed me” was Pistol’s second album released by Street Flavor Records in 1995.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/rude.png" alt="" />
            <p>Rude Awakening’s self-titled album was released in 1995 by Street Flavor Records.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/papajay.png" alt="" />
            <p>Papa Jay “Manhunt” was released in 1995 by Street Flavor Records.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/crookedeye.jpg" alt="" />
            <p>Crooked EyeQ’s debut album was released in 1997 by Street Flavor Records.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/backwithvengence.png" alt="" />
            <p>“Back with a vengeance” was a compilation album released in 1997 by Street Flavor Records which featured Young Buck, Papa Jay, Pistol, and Boogie.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/kool.png" alt="" />
            <p>Kool Daddy Fresh’s album “The whole truth so help me” was released in 1998 by Street Flavor Records.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/kacino.png" alt="" />
            <p>Kacino “Life is a gamble” was released by Street Flavor Records in 1998.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/makmiilion.jpg" alt="" />
            <p>Haystak “Mak Million” was released by Street Flavor Records in 1998, which paved the way for an entire subgenre of southern hip-hop and opened doors to Nashville’s biggest independent artists.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/carfullawhite.jpg" alt="" />
            <p>Haystak “Car fulla whiteboys” was released by Street Flavor Records in 2000.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/thenatural.jpg" alt="" />
            <p>Haystak “The Natural” was released by Street Flavor Records in 2002.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/burnaz.png" alt="" />
            <p>The Burnaz self-titled album was released by Street Flavor Records in 2002.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/returnofmak.jpg" alt="" />
            <p>Haystak “Return of the Make Million” was released by Street Flavor Records in 2003.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/portrait.jpg" alt="" />
            <p>Haystak “Portrait of a whiteboy” was released by Street Flavor Records in 2004, marking the beginning of a three-album trilogy that changed Nashville hip-hop forever.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/fromstarttofinish.jpg" alt="" />
            <p>Haystak “From start to finish” was released by Street Flavor Records in 2005. It featured classics like “All by myself,” “Bonnie and Clyde,” and guest spots from 8-Ball and Bun-B.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/hategoeson.jpg" alt="" />
            <p>Jelly Roll’s debut album “The Hate Goes On” was released by Street Flavor Records in 2006.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/sfmixtape.jpg" alt="" />
            <p>The Street Flavor Mixtape “Volume 1” was released in 2006, featuring Jelly Roll, Haystak, Charlie P, and many more.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/locallegend.jpg" alt="" />
            <p>Charlie P’s debut album “Local Legend” was released by Street Flavor Records in 2007.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/crack.jpg" alt="" />
            <p>Haystak “Crackaveli” was released by Street Flavor Records in 2007; the double-disc album marked the end of the iconic trilogy.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/bossmixtape.jpg" alt="" />
            <p>Haystak “The Boss Mixtape Volume 1” was released by Street Flavor Records in 2007.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/basement.jpg" alt="" />
            <p>Haystak “The Basement Tapes” was released by Street Flavor Records in 2015—the first Haystak/Street Flavor project since 2007.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/addictionkills.jpg" alt="" />
            <p>Jelly Roll “Addiction Kills” was a Street Flavor production released in 2017; the album has since produced three gold singles.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/makeherdance.jpg" alt="" />
            <p>Lorenzo Cole’s debut single “Make Her Dance” was released by Street Flavor Records in 2019.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/onlyyou.jpg" alt="" />
            <p>Lorenzo Cole “Only You” was released by Street Flavor Records in 2019.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/overnight gimmick.jpg" alt="" />
            <p>Leroy Biggs “Overnight Gimmick” was released by Street Flavor Records in 2021 after a small hiatus.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/explode.jpg" alt="" />
            <p>Lorenzo Cole “Explode” was released by Street Flavor Records in 2022.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/poa.jpg" alt="" />
            <p>Lorenzo Cole “Piece of America” was released by Street Flavor Records in 2022.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/howdy.JPG" alt="" />
            <p>Leroy Biggs “Howdy Howdy” was released by Street Flavor Records in 2022 in association with MNRK Music Group.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/sauce.jpg" alt="" />
            <p>Lorenzo Cole “Sauce King” (ft. Deuce, Leroy Biggs & Chucky Velvet) was released by Street Flavor Records in 2022.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/sober.JPG" alt="" />
            <p>Leroy Biggs “Sober” was released by Street Flavor Records in 2022.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/phonto.JPG" alt="" />
            <p>Leroy Biggs “Villain” was a leaked performance track released by Street Flavor Records in 2022.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/weride.jpg" alt="" />
            <p>Lorenzo Cole “WE RIDE” (ft. Jelly Roll & Leroy Biggs) was released by Street Flavor Records in late 2022.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/mrbiggs.jpg" alt="" />
            <p>Leroy Biggs’ 4th studio album “Mr. Biggs” was released by Street Flavor Records in 2023—the first LP since The Basement Tapes (2015).</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/shitshow.jpg" alt="" />
            <p>Lorenzo Cole “Shit Show” (ft. Leroy Biggs) was released by Street Flavor Records in 2023.</p>
          </div>
          <div className="timeline-item">
            <img src="/SF WEB IMAGES/broken.jpg" alt="" />
            <p>Lorenzo Cole “Broken” was released by Street Flavor Records in 2023.</p>
          </div>
        </div>
      </section>
    </main>

    <footer>
      <p>&copy; 2025 Street Flavor Records / SPNDAT INC. All rights reserved.</p>
    </footer>
  </>
);

export default History;
